window.addEventListener('load', () => {
  if (window.Styxie?.deferredInit) {
    window.Styxie.deferredInit()
  }
})
